import { tokenService } from './tokenService';

export const initAuth = async (): Promise<boolean> => {
  try {
    const accessToken = tokenService.getAccessToken();
    if (accessToken) {
      return true;
    }
    return false;
  } catch {
    tokenService.clear();
    return false;
  }
};
